import YFormSelectTag from './SelectTag';

export { YFormSelectTag };
export default YFormSelectTag;
